// Components
import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { Dispatch, SetStateAction } from 'react';

import { Button } from '@/components/Button';
// Styles
import styles from '@/components/Clients/EmptySessionState.module.css';
import { Icon } from '@/components/Icon';
import { IconSize } from '@/components/Icon/types';

type EmptyClientStateProps = {
  onClickEvent: Dispatch<SetStateAction<boolean>>;
};

//TODO: Change Icon
export const EmptySessionState = ({ onClickEvent }: EmptyClientStateProps) => {
  return (
    <>
      <IonGrid className={styles.wrapper}>
        <IonRow
          className='ion-align-items-center ion-justify-content-center ion-margin-vertical'
          style={{ width: '100%' }}>
          <IonCol className='ion-no-padding ion-text-center' size='12'>
            <Icon className={styles.icon} color='#2DD2BE' name='plus' size={IconSize.extraExtraLarge} />
            <h1 className={styles.title}>Add your first session</h1>
            {/* <IonText className={styles['sub-title']}>
              Start tracking movement data and analysis for your clients. Each client can be associated with their test
              sessions.
            </IonText> */}
          </IonCol>
        </IonRow>
        <IonRow
          className='ion-align-items-center ion-justify-content-center ion-padding-vertical'
          style={{ width: '100%' }}>
          <Button leadingIcon='plus' onClick={() => onClickEvent(true)} size='medium' variant='primary'>
            Add new Session
          </Button>
        </IonRow>
      </IonGrid>
    </>
  );
};
